import { teamSections } from "../data/teamData";
import TeamSection from "./TeamSection";

function Team() {
    return (
        <section id="team" aria-label="Team section" className="bg-gradient-to-b from-black to-dark px-6 py-10">
            {teamSections.map((section, index) => (
                <TeamSection
                    key={index}
                    headings={section.headings}
                    members={section.members}
                    orientation={section.orientation}
                    text={section.text}
                />
            ))}
        </section>
    );
}

export default Team;
